import type { ReactNode } from "react";

import { useTranslation } from "pro-features/components/WithTranslation";

import type { IWidgetCardLayoutProps } from "../../components/WidgetCardLayout";
import { TRAFFIC_SOURCES, type TrafficSource } from "../traffic-sources-tabs/constants";
import { WidgetCard } from "../WidgetCard";

interface IPdfTrafficSourcesListProps extends Pick<IWidgetCardLayoutProps, "automationIds"> {
    children: (trafficSource: TrafficSource) => ReactNode;
}

export const PdfTrafficSourcesList = ({ children, ...other }: IPdfTrafficSourcesListProps) => {
    const translate = useTranslation();

    return (
        <>
            {TRAFFIC_SOURCES.map(({ title, value }) => (
                <WidgetCard
                    {...other}
                    key={`pdf-widget-card-${value}`}
                    title={translate(title)}
                    className="avoidBreakInside"
                >
                    {children(value)}
                </WidgetCard>
            ))}
        </>
    );
};
